// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__27FEe","location":"Header_location__2MGji"};